import { CheggEnv } from '@chegg/utils'
import * as React from 'react'
import { connect } from 'react-redux'
import { WritingCheckout } from '@chegg/writing-checkout'
import { getCheggAccessToken, getCheggIdToken } from '@src/state/auth/selectors'
import { getUpsellVariation } from '@src/state/featureFlags/selectors'
import { UpsellVariation } from '@src/state/featureFlags/types'
import { PAYMENT_MODAL } from '@src/state/modals/actions'
import { getQueryParams } from '@src/state/router/selectors'
import { getSite, getSiteConfig } from '@src/state/site/selectors'
import { SiteConfig, SiteState } from '@src/state/site/types'
import { RootState } from '@src/state/types'
import { PAYMENT_MODAL_TEST_ID } from '@src/utils/dataTestIds'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import QueryString from 'qs'
import { COUNTRYCODE, REGION } from './constants'
import { BaseModalContainer } from './styles'
import { siteToProductCode, siteToPlanCode } from './utils'
import { HostCallbackPayload } from '@chegg/commerce-utils'

export const DEFAULT_PRICE = '$9.95'
export const DEFAULT_FREE_TRIAL = true
export const DEFAULT_PRICING_EXPERIMENT = 'BASE'
export const DEFAULT_BASE_PRICE = 9.95

interface CheckoutWrapperProps {
  site: SiteState
  authToken: AuthToken
  siteConfig: SiteConfig
  closePaymentModal: () => void
  callback: (oneClickCallbackPayload: HostCallbackPayload) => void
  onHostRedirect: () => void
  queryParams: QueryString.ParsedQs
  upsellVariation: UpsellVariation
}

interface AuthToken {
  accessToken: string
  idToken: string
}

export const CheckoutWrapper: React.FC<CheckoutWrapperProps> = ({
  callback = () => {},
  onHostRedirect,
  closePaymentModal,
  site,
  authToken,
  siteConfig,
  queryParams,
}) => {
  const countryCode =
    queryParams[COUNTRYCODE] && LOCAL_OR_PLAYGROUND
      ? (queryParams[COUNTRYCODE] as string)
      : undefined
  const region =
    queryParams[REGION] && LOCAL_OR_PLAYGROUND
      ? (queryParams[REGION] as string)
      : undefined

  const checkoutComponent = (
    <WritingCheckout
      siteName={site}
      authConfig={{ sdkKey: siteConfig.dipApiKey }}
      productConfig={{
        planCode: siteToPlanCode[site],
        productCode: siteToProductCode[site],
      }}
      location={{
        countryCode,
        region,
      }}
      callback={callback}
      analyticsInfo={{
        pageName: 'Upgrade',
        transactionSource: site,
      }}
      environment={LOCAL_OR_PLAYGROUND ? CheggEnv.TEST : CheggEnv.PROD}
      onClickNoThanks={closePaymentModal}
      onHostRedirect={onHostRedirect}
      isModal={true}
      onClose={closePaymentModal}
    />
  )

  return (
    <BaseModalContainer
      testId={PAYMENT_MODAL_TEST_ID}
      name={PAYMENT_MODAL}
      dismissible={false}
      onBackdropClick={closePaymentModal}
    >
      {checkoutComponent}
    </BaseModalContainer>
  )
}

const mapStateToProps = (state: RootState) => ({
  site: getSite(state),
  authToken: {
    accessToken: getCheggAccessToken(state),
    idToken: getCheggIdToken(state),
  } as AuthToken,
  siteConfig: getSiteConfig(state),
  queryParams: getQueryParams(state),
  upsellVariation: getUpsellVariation(state),
})

export default connect(mapStateToProps)(CheckoutWrapper)



// WEBPACK FOOTER //
// ./src/components/Modals/PaymentModal/checkout.tsx